import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Shop from "@/components/Shop";
import VaultRegistry from "@/components/VaultRegistry";
import Manifesto from "@/components/Manifesto";
import Lookbook from "@/components/Lookbook";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";

export default function Home({ ready }) {
  return (
    <div className="relative">
      <Header />
      <main>
        <Hero ready={ready} />
        <Marquee />
        <Shop />
        <VaultRegistry />
        <Manifesto />
        <Lookbook />
      </main>
      <Footer />
      <CartDrawer />
    </div>
  );
}
